import {MiniCartInit} from "./components/mini-cart";
import {activateDeferredLinks} from "./components/deferred-links";
import {ProductDescriptionCollapseInit} from "./components/product-description-collapse";
import {ProductFaqCollapseInit} from "./components/product-faq-collapse";
import {ConsentsCollapseInit} from "./components/consents";
import {initPostTagsWrapper} from "./components/post-tags-wrapper";
import {initNavbar} from "./components/navbar";
import {initCommentFormFix} from "./components/comment-form-fix";
import {initCheckoutPage} from "./components/checkout-page";
import {ProductQuantityInit} from "./components/product-quantity";
import {Wp7formValidator} from "./components/wp7form-validator";
// import {initExitPopupCustom} from "./components/exit-popup-custom";

MiniCartInit();

document.addEventListener('DOMContentLoaded',function() {

    initNavbar();
    ProductDescriptionCollapseInit();
    activateDeferredLinks();
    ProductFaqCollapseInit();
    ConsentsCollapseInit();
    initPostTagsWrapper();
    initCommentFormFix();
    // initExitPopupCustom();
    initCheckoutPage();
    ProductQuantityInit();
    Wp7formValidator();
})